import { render, staticRenderFns } from "./JeongDahoon.vue?vue&type=template&id=d22a33b8&scoped=true"
import script from "./JeongDahoon.vue?vue&type=script&lang=js"
export * from "./JeongDahoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a33b8",
  null
  
)

export default component.exports